/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProjectById,
  updateProject,
  AddProjectMember,
  updateProjectMember,
  RemoveProjectMember,
} from '../../../redux/MainAction';
import moment from 'moment';
import Select from 'react-select';
import { toast } from 'react-toastify';

const EditProject = ({ open, onClose, ID }) => {
  const dispatch = useDispatch();
  const tmlist = useSelector((state) => state.Webtracker.member);
  const single = useSelector((state) => state?.Webtracker?.projectByID);

  const percentage = 0;

  const [empDataOption, setEmpDataOption] = useState('');
  const [empDataValue, setEmpDataValue] = useState([]);
  const [emValue, setEmValue] = useState([]);

  const [switch1, setSwitch1] = useState(true);

  const [editData, setEditData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    timeEstimate: null,
    budgetEstimate: null,
    projectNotes: '',
    weeklyLimitPerMember: null,
    hourlyRate: null,
    screenshotMode: '',
  });

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleSwitchChange = () => {
    setSwitch1(!switch1);
  };

  useEffect(() => {
    if (ID) getList();
  }, [ID]);

  const getList = () => {
    var data = {
      id: ID,
    };
    dispatch(getProjectById(data));
  };

  const onChangeMember = (e, idx) => {
    const { name, value } = e.target; // Extract the field name and value from the event
    const updatedMembers = [...emValue]; // Create a shallow copy of the projectMembers array

    // Update the specific field of the selected member
    updatedMembers[idx] = {
      ...updatedMembers[idx], // Keep other fields unchanged
      [name]: value, // Update the field that changed
    };
    console.log('updatedMembers', updatedMembers);
    setEmValue(updatedMembers);
  };

  useEffect(() => {
    if (single) {
      setEditData({
        name: single?.name,
        startDate: single?.startDate
          ? moment(single?.startDate).format('YYYY-MM-DD')
          : '',
        endDate: single?.endDate
          ? moment(single?.endDate).format('YYYY-MM-DD')
          : '',
        timeEstimate: +single?.timeEstimate,
        budgetEstimate: +single?.budgetEstimate,
        projectNotes: single?.projectNotes || '',
        weeklyLimitPerMember: +single?.weeklyLimitPerMember,
        hourlyRate: +single?.hourlyRate,
        screenshotMode: single?.screenshotMode,
      });

      const empIdsInRecords = single?.projectMembers?.map(
        (record) => record?.employeeId
      );
      const filteredEmployees = tmlist?.rows?.filter(
        (employee) => !empIdsInRecords?.includes(employee?.id)
      );
      setEmpDataValue(filteredEmployees);
      setSwitch1(single?.isBillable);
      setEmValue(single?.projectMembers);
    }
  }, [single, tmlist]);

  const onSaveHandle = (e) => {
    e.preventDefault();
    const payload = {
      id: ID,
      name: editData?.name,
      ...(editData?.startDate
        ? { startDate: moment(editData?.startDate).format('YYYY-MM-DD') }
        : {}),
      ...(editData?.endDate
        ? { endDate: moment(editData?.endDate).format('YYYY-MM-DD') }
        : {}),
      ...(parseFloat(editData?.timeEstimate)
        ? { timeEstimate: parseFloat(editData?.timeEstimate) }
        : {}),
      ...(parseFloat(editData?.budgetEstimate)
        ? { budgetEstimate: parseFloat(editData?.budgetEstimate) }
        : {}),
      ...(parseFloat(editData?.weeklyLimitPerMember)
        ? { weeklyLimitPerMember: parseFloat(editData?.weeklyLimitPerMember) }
        : {}),
      ...(parseFloat(editData?.hourlyRate)
        ? { hourlyRate: parseFloat(editData?.hourlyRate) }
        : {}),
      screenshotMode: editData?.screenshotMode,
      isBillable: switch1,
      ...(editData?.projectNotes
        ? { projectNotes: editData?.projectNotes }
        : {}),
    };

    dispatch(updateProject(payload));
    onClose();
  };

  const onSaveMember = (e) => {
    e.preventDefault();

    if (empDataOption === '') {
      toast.error('Please Add a Member !', {
        position: 'top-right',
      });
    }
    const selectedProject = single;

    var saveMember = {
      projectId: ID,
      employeeId: empDataOption,
      ...(selectedProject?.hourlyRate
        ? { hourlyRate: +selectedProject?.hourlyRate }
        : {}),
      ...(selectedProject?.screenshotMode
        ? { screenshotMode: selectedProject?.screenshotMode }
        : {}),
      ...(selectedProject?.weeklyLimitPerMember
        ? { weeklyLimitPerMember: +selectedProject?.weeklyLimitPerMember }
        : {}),
    };

    dispatch(AddProjectMember(saveMember));
  };

  const handleUpdate = (id) => {
    const flsRec = emValue?.filter((rec) => rec?.id === id)[0];

    const updTM = {
      projectMemberId: id,
      ...(flsRec?.hourlyRate ? { hourlyRate: +flsRec?.hourlyRate } : {}),
      ...(flsRec?.hourlyRateType
        ? { hourlyRateType: flsRec?.hourlyRateType }
        : {}),
      ...(flsRec?.weeklyLimitPerMember
        ? { weeklyLimitPerMember: +flsRec?.weeklyLimitPerMember }
        : {}),
      ...(flsRec?.screenshotMode
        ? { screenshotMode: flsRec?.screenshotMode }
        : {}),
    };
    dispatch(updateProjectMember(updTM, ID));
  };

  const handleDelete = (id) => {
    var del = {
      projectMemberId: id,
    };
    dispatch(RemoveProjectMember(del, ID));
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className={`overlay ${open ? 'open' : ''}`} id="myNav">
            {/* <a href="javascript:void(0)" className="closebtn" >&times;</a> */}
            <div className="overlay-content">
              <ul
                className=" nav nav-tabs nav-tabs-custom  nav-justified"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#project"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Project Details</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-home-variant h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#properties"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Properties</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-email h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#members"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Members</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-account h5"></i>
                    </span>
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div
                  className="tab-pane active p-2"
                  id="project"
                  role="tabpanel"
                  style={{ overflowY: 'auto' }}
                >
                  <div className="form-group">
                    <label className="text-muted" for="name">
                      Project Name
                    </label>
                    <div
                      className="d-flex justify-content-start align-items-center"
                      style={{ gap: '5px' }}
                    >
                      <i className="mdi mdi-buffer col-sm-1 border rounded pr_icon"></i>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        id="name"
                        placeholder="Enter name"
                        value={editData?.name}
                        onChange={onHandleChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <div className="">
                      <input
                        type="checkbox"
                        id="switch"
                        switch="purple"
                        checked={switch1}
                        onChange={handleSwitchChange}
                      />
                      <label
                        htmlFor="switch"
                        data-on-label=""
                        data-off-label=""
                      ></label>
                    </div>
                    <span className="ml-3 font-16">Billable</span>
                  </div>
                  <div
                    className="d-flex justify-content-between"
                    style={{ gap: '5px' }}
                  >
                    <div className="form-group ">
                      <label for="username1" className="font-14 text-muted ">
                        Start
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="username1"
                        style={{ maxWidth: '130px' }}
                        name="startDate"
                        value={editData?.startDate}
                        onChange={onHandleChange}
                      />
                    </div>
                    <div className="form-group  ">
                      <label for="username2" className="font-14 text-muted ">
                        End
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        id="username2"
                        style={{ maxWidth: '130px' }}
                        name="endDate"
                        value={editData?.endDate}
                        onChange={onHandleChange}
                      />
                    </div>
                    <div className="form-group ">
                      <label
                        for="username "
                        className="font-14 text-muted text-nowrap "
                      >
                        Time estimate
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="username"
                        name="timeEstimate"
                        value={editData?.timeEstimate}
                        onChange={onHandleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        for="username3 "
                        className="font-14 text-muted text-nowrap"
                      >
                        Budget estimate
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id="username3"
                        name="budgetEstimate"
                        value={editData?.budgetEstimate}
                        onChange={onHandleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Notes</label>
                    <textarea
                      type="text"
                      className="form-control"
                      rows={4}
                      placeholder="Notes"
                      name="projectNotes"
                      value={editData?.projectNotes}
                      onChange={onHandleChange}
                    />
                  </div>
                  <div className="d-flex" style={{ gap: '10px' }}>
                    <Button className="" onClick={onClose} size="sm">
                      Close
                    </Button>
                    <Button
                      outline
                      size="sm"
                      color="primary"
                      onClick={onSaveHandle}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="tab-pane p-3" id="members" role="tabpanel">
                  <div className="d-flex ">
                    <div className="d-flex col-12 mb-2 justify-content-between">
                      <div style={{ width: '50%' }}>
                        <select
                          className="form-control font-14"
                          value={empDataOption}
                          onChange={(e) => setEmpDataOption(e.target.value)}
                        >
                          <option value="">Add Member</option>
                          {empDataValue?.length > 0 ? (
                            empDataValue?.map((memo, idx) => (
                              <option key={idx} value={memo?.id}>
                                {memo?.firstName} {memo?.lastName}
                              </option>
                            ))
                          ) : (
                            <option value={''}>No Members</option>
                          )}
                        </select>
                      </div>
                      <div className="">
                        <Button
                          size="sm"
                          color="primary"
                          onClick={onSaveMember}
                        >
                          Add Member
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex col-12 tab_p">
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th className="text-nowrap">Member</th>
                          <th className="text-nowrap">Hourly rate</th>
                          <th className="text-nowrap">Weekly limit</th>
                          <th className="text-nowrap">Screenshot mode</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {emValue?.map((prj, idx) => (
                          <tr key={prj.id}>
                            <td className="text-nowrap">
                              <div>
                                {prj?.employee?.firstName}{' '}
                                {prj?.employee?.lastName}
                              </div>
                            </td>
                            <td className="text-nowrap">
                              <div className="proj_assing">
                                <select
                                  className="form-control font-14"
                                  name="hourlyRateType"
                                  value={prj?.hourlyRateType}
                                  onChange={(e) => onChangeMember(e, idx)}
                                >
                                  <option value="CUSTOM-RATE">
                                    Custom Rate
                                  </option>
                                  <option value="MEMBER-RATE">
                                    Member Rate
                                  </option>
                                  <option value="PROJECT-RATE">
                                    Project Rate
                                  </option>
                                </select>
                                <input
                                  type="number"
                                  id="limit7"
                                  disabled={
                                    prj?.hourlyRateType !== 'CUSTOM-RATE'
                                  }
                                  title="Can be edited for custom rate only"
                                  placeholder="0"
                                  className="form-control"
                                  name="hourlyRate"
                                  value={prj?.hourlyRate}
                                  onChange={(e) => onChangeMember(e, idx)}
                                />
                              </div>
                            </td>
                            <td className="text-nowrap">
                              <div className="proj_addBtn">
                                <i className="fa fa-pencil addBtn_icon"></i>
                                <input
                                  type="number"
                                  id="limit8"
                                  placeholder="0"
                                  name="weeklyLimitPerMember"
                                  className="form-control"
                                  value={prj?.weeklyLimitPerMember}
                                  onChange={(e) => onChangeMember(e, idx)}
                                />
                              </div>
                            </td>
                            <td className="text-nowrap">
                              <div style={{ width: '150px' }}>
                                <select
                                  className="form-control font-14"
                                  name="screenshotMode"
                                  value={prj?.screenshotMode}
                                  onChange={(e) => onChangeMember(e, idx)}
                                >
                                  <option value="SCREENSHOT">Screenshot</option>
                                  <option value="NO-SCREENSHOT">
                                    No Screenshot
                                  </option>
                                  <option value="BACKGROUND">Background</option>
                                  <option value="BLURRED-SCREENSHOT">
                                    Blurred Screenshot
                                  </option>
                                </select>
                              </div>
                            </td>
                            <td className="text-nowrap">
                              <Button
                                size="sm"
                                color="primary"
                                className="mr-1"
                                onClick={() => handleUpdate(prj?.id)}
                              >
                                Update
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => handleDelete(prj?.id)}
                              >
                                <i className="fa fa-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex mt-3" style={{ gap: '10px' }}>
                    <Button className="" onClick={onClose} size="sm">
                      Close
                    </Button>
                  </div>
                </div>
                <div className="tab-pane p-3" id="properties" role="tabpanel">
                  <div>
                    <div className="d-flex justify-content-between">
                      <div className="form-group">
                        <label for="limit " className="font-14 text-muted">
                          Weekly limit per member
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="limit"
                          name="weeklyLimitPerMember"
                          value={editData?.weeklyLimitPerMember}
                          onChange={onHandleChange}
                        />
                      </div>
                      <div className="form-group">
                        <label for="rate" className="font-14 text-muted">
                          Hourly rate
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="rate"
                          name="hourlyRate"
                          value={editData?.hourlyRate}
                          onChange={onHandleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="text-muted">Screenshot Mode</label>
                      <div className="">
                        <select
                          className="form-control"
                          name="screenshotMode"
                          value={editData?.screenshotMode}
                          onChange={onHandleChange}
                        >
                          <option value="SCREENSHOT">Screenshot</option>
                          <option value="NO-SCREENSHOT">No Screenshot</option>
                          <option value="BACKGROUND">Background</option>
                          <option value="BLURRED-SCREENSHOT">
                            Blurred Screenshot
                          </option>
                        </select>
                      </div>
                      <div className="border bg-light p-2 mt-3 text-center rounded">
                        <span className="text-muted">
                          <i className="mdi mdi-information-outline font-18 mt-1"></i>{' '}
                          These properties apply to members in the scope of this
                          project only.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex" style={{ gap: '10px' }}>
                    <Button className="" onClick={onClose} size="sm">
                      Close
                    </Button>
                    <Button
                      outline
                      size="sm"
                      color="primary"
                      onClick={onSaveHandle}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="tab-pane p-3" id="overview" role="tabpanel">
                  <div className="col-12 mt-4 d-flex justify-content-around align-items-center">
                    <div className="col-5 d-flex flex-column">
                      <div className="p-2 d-flex justify-content-around align-items-center rounded overview_border">
                        <i className=" shadow-sm mdi mdi-calendar-blank text-purple p-2 rounded bg-white font-18"></i>
                        <div className="d-flex flex-column">
                          <span className="text-muted">Created</span>
                          <span className="text-muted">Last Updated</span>
                        </div>
                        <div className="d-flex flex-column">
                          <span className="text-muted">30.10.2024</span>
                          <span className="text-muted">31.10.2024</span>
                        </div>
                      </div>
                      <div
                        className="mt-3 p-3 d-flex flex-column justify-content-around align-items-center rounded overview_border1"
                        style={{ gap: '10px' }}
                      >
                        <i className=" shadow-sm mdi mdi-account-multiple text-warning p-2 rounded bg-white font-20"></i>
                        <span className="text-muted">Assigned Users</span>
                        <span className="text-muted">AS</span>
                      </div>
                    </div>
                    <div className="col-5 border rounded border-success p-3">
                      <div className="d-flex flex-column justify-content-around align-items-center p-2">
                        <i className=" shadow-sm mdi mdi-checkbox-marked-outline text-success p-2 rounded bg-white font-20"></i>
                        <span className="text-muted font-14 mt-3">
                          Active Tasks
                        </span>
                        <span className="text-muted font-14">Go to tasks</span>
                      </div>
                      <div className="d-flex justify-content-around align-items-center">
                        <div style={{ width: 70, height: 70 }}>
                          <CircularProgressbar
                            value={percentage}
                            text={`${percentage}%`}
                          />
                        </div>
                        <div className="d-flex flex-column">
                          <span className="font-13">
                            <i className="mdi mdi-checkbox-blank"></i> All Tasks
                          </span>
                          <span>
                            {' '}
                            <i className="mdi mdi-checkbox-blank text-success"></i>{' '}
                            Completed
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default EditProject;
